import React from 'react';

import PageLoader from 'ui/PageLoader';

const LoaderStep = () => <PageLoader />;

export default LoaderStep;
